angular.module('picmonic-common')
    .controller("RegisterModalController", ['$scope', '$modalInstance', '$controller', '$location', 'UserService', 'MarketOptionsConfig', 'card', 'copy', 'market_id', 'redirect', 'tab', '$cookies', '$modal', 'registration_source_page', '$state', '$timeout', function($scope, $modalInstance, $controller, $location, UserService, MarketOptionsConfig, card, copy, market_id, redirect, tab, $cookies, $modal, registration_source_page, $state, $timeout){
        $controller('LoginController', {$scope: $scope});
        $controller('RegisterStep1Controller', {$scope: $scope});

        $modalInstance.opened.then(function(){
            $timeout(function() {
                $('.modal').scrollTop(0);
            });
        });

        $scope.UserService = UserService;
        $scope.MarketOptionsConfig = MarketOptionsConfig;

        $scope.current_url = location.pathname;

        $scope.copy = copy;
        $scope.card = card;
        $scope.$emit('endInteraction');

        $scope.name = card?card.name:'';
        
        // Default the market ID to user's lead, then cookie, then 100 as fallback
        if(!market_id) {
          market_id = $cookies.get('pls_user_lead') ? $cookies.get('pls_user_lead') : null;
        }
        
        if(market_id) {
            var market = MarketOptionsConfig.getMarketById(market_id);
            $scope.market_name = market.school_name;
        }
        
        $scope.tab = tab ? tab : ($cookies.get('userId') ? 'login' : 'register');

        send_ga('event', 'Register', 'Registration Modal', 'Tab: '+$scope.tab);
        if(typeof atlasEvent !== 'undefined') {
            atlasEvent('registration-modal', 'Tab: '+$scope.tab, 'new_user');
            atlasEvent('registration-modal', 'Tab: '+$scope.tab, 'user_flow_7_2017', 'required');
        }

        $scope.years = [];
        var start_year = new Date().getFullYear();
        for (var a = 0; a < 10; a++) {
            $scope.years.push(start_year + a);
        }

        $scope.months = {
            1: 'January',
            2: 'February',
            3: 'March',
            4: 'April',
            5: 'May',
            6: 'June',
            7: 'July',
            8: 'August',
            9: 'September',
            10: 'October',
            11: 'November',
            12: 'December'
        };


        //Submit user object to user endpoint (update user)
        $scope.submitSchool = function () {
            if ($scope.form.$invalid) {
                $scope.error = 'Please complete all required fields';
                return;
            } else {
                $scope.error = '';
            }

            if (UserService.user.graduation_year || UserService.user.graduation_month || UserService.user.student_officer || UserService.user.link || (UserService.user.school && UserService.user.school.id)) {
                if(typeof atlasEvent !== 'undefined') {
                    atlasEvent('click', 'registration step 3 finished');
                }
            } else {
                if(typeof atlasEvent !== 'undefined') {
                    atlasEvent('click', 'registration step 3 skipped');
                }
            }

            $scope.loading = true;
            $scope.error = null;

            UserService.user.$update(function (data) {
                $scope.checkRedirect();
            }, function (error) {
                $scope.error = error.data.message;
                $scope.loading = false;
            });
        };

        $scope.checkRedirect = function(){
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            var isMobileAndroidApp = ((userAgent.indexOf('Crosswalk') > -1) || (userAgent.indexOf('CriOS') > -1));
            var urlparams = $location.search();

            if (card && card.slug) {
                if (!isMobileAndroidApp && /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4))) {
                    top.location = $location.protocol() + '://' + $location.host() + '/login/mobile-app?redirect=' + '/learn/' + card.slug;
                } else {
                    document.location.href = '/learn/' + card.slug;
                }
            } else if (redirect) {
                if (redirect === 'close') {
                    $modalInstance.close();
                } else if (redirect.indexOf('challenge') !== -1) {
                    document.location.href = redirect;
                } else if (!isMobileAndroidApp && /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4))) {
                    top.location = $location.protocol() + '://' + $location.host() + '/login/mobile-app?redirect=' + encodeURIComponent(redirect);
                } else if (redirect.indexOf('?newWindow') !== -1) {
                    window.open(redirect);
                    $modalInstance.close();
                } else {
                    document.location.href = redirect;
                }
            } else {
                if ($scope.tab == 'login') {
                    if (!isMobileAndroidApp && /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4))) {
                        top.location = $location.protocol() + '://' + $location.host() + '/login/mobile-app?redirect=' + (urlparams.redirect ? urlparams.redirect : '/home');
                    } else {
                        location.reload();
                    }
                } else {
                    top.location = '/find-picmonic?market='+MarketOptionsConfig.getMarketById(UserService.user.lead).slug;
                }
            }

        };

        $scope.submitModalSocialLogin = function() {
            $scope.loading = true;
            $scope.loadingMode = 'login-social';
            $scope.error = '';

            $scope.socialLogin(false, redirect).then(function(){
                $scope.checkRedirect();
            }, function(error){
                $scope.error = error.data.message.replace('/login', '/login?redirect='+$scope.current_url);
                $scope.loading = false;
            });
        };

        $scope.submitModalLogin = function(){
            $scope.loading = true;
            $scope.loadingMode = 'login-picmonic';
            $scope.error = '';

            $scope.appLogin(false, redirect).then(function(){
                $scope.checkRedirect();
            }, function(error){
                $scope.error = error.data.message.replace('/login', '/login?redirect='+$scope.current_url);
                $scope.loading = false;
            });
        };

        $scope.submitModalSocialRegistration = function() {
            $scope.loading = true;
            $scope.loadingMode = 'registration-social';
            $scope.error = '';

            if (market_id) {
                if (!MarketOptionsConfig.getMarketById(market_id).is_pseudo) {
                    UserService.user.lead = market_id;
                }
                UserService.user.role = 'Student';
            }

            UserService.user.registration_source_page = registration_source_page;

            // Call RegisterStep1Controller.register
            $scope.socialRegister(false, redirect).then(function(data){
                $scope.loading = false;

                if (data && data.lead) {
                    market = MarketOptionsConfig.getMarketById(data.lead);
                    $scope.tab = 'login';
                }

                if (market && redirect && redirect.indexOf('nursing-nclex-question-of-the-day') !== -1) {
                    $scope.checkRedirect();
                } else if (!market || (market && market.is_pseudo)) {
                    $scope.tab = 'market';
                } else if (market.show_school_modal && !(data.school && data.school.school_id)) {
                    $scope.tab = 'school';
                } else {
                    $scope.checkRedirect();
                }
            }, function(error){
                $scope.error = error.data.message.replace('/login', '/login?redirect='+$scope.current_url);
                $scope.loading = false;
            });
        };

        $scope.submitModalRegistration = function(){
            if (market_id) {
                if (!MarketOptionsConfig.getMarketById(market_id).is_pseudo) {
                    $scope.user.lead = market_id;
                }
                $scope.user.role = 'Student';
            }
            $scope.user.accessToken = null;
            $scope.user.registration_source_page = registration_source_page;
            $scope.loading = true;
            $scope.loadingMode = 'registration-picmonic';
            $scope.error = '';

            // Call RegisterStep1Controller.register
            $scope.register(false, redirect).then(function(data){
                // Check if the user already has an account and we instead logged them in
                if (data && data.lead) {
                    market = MarketOptionsConfig.getMarketById(data.lead);
                    $scope.tab = 'login';
                }

                if (redirect && redirect.indexOf('nursing-nclex-question-of-the-day') !== -1) {
                    $scope.checkRedirect();
                } else if (!market || (market && market.is_pseudo)) {
                    $scope.tab = 'market';
                } else if (market.show_school_modal && !(data.school && data.school.school_id)) {
                    if(typeof atlasEvent !== 'undefined') {
                        atlasEvent('click', 'registration step 2 skipped');
                    }
                    $scope.tab = 'school';
                } else {
                    $scope.checkRedirect();
                }
            }, function(error){
                $scope.error = error.data.message_html.replace('/login', '/login?redirect='+$scope.current_url);
                $scope.loading = false;
            });
        };

        $scope.submitMarket = function(){
            if (!$scope.user.lead) {
                $scope.error = 'Please select an area of Study.';
                return false;
            }
            market = MarketOptionsConfig.getMarketById($scope.user.lead);
            $scope.loading = true;
            $scope.error = null;

            UserService.user.$update(function(data){
                if (redirect && redirect.indexOf('nursing-nclex-question-of-the-day') !== -1) {
                    $scope.checkRedirect();
                } else if (market.show_school_modal) {
                    $scope.tab = 'school';
                } else {
                    $scope.checkRedirect();
                }
            }, function(error){
                $scope.error = error.data.message.replace('/login', '/login?redirect='+$scope.current_url);
                $scope.loading = false;
            });
        };

        $scope.selectTab = function(tab){
            $scope.tab = tab;
        };

        $scope.close = function(){
            if(typeof atlasEvent !== 'undefined' && $scope.tab === 'school') {
                atlasEvent('click', 'registration step 3 skipped');
            }

            if (UserService.user.user_id) {
                $scope.checkRedirect();
            }
            $modalInstance.close();
        };
    }])
    .value('tab', null)
    .value('card', false)
    .value('copy', '')
    .value('redirect', false)
    .value('market_id', false)
    .value('registration_source_page', null);
